import {SPEED} from "./cooks";
import {Position} from "./game_element_schema";

export enum Directions {
    UP = "up",
    DOWN = "down",
    UPLEFT = "upleft",
    UPRIGHT = "upright",
    DOWNLEFT = "downleft",
    DOWNRIGHT = "downright",
    LEFT = "left",
    RIGHT = "right",
}

export function convertDirectionToXY(direction: Directions): DirectionXY {
    let x: 1 | 0 | -1 = 0
    let y: 1 | 0 | -1 = 0

    switch (direction) {
        case Directions.DOWN:
        case Directions.DOWNLEFT:
        case Directions.DOWNRIGHT:
            y = 1
            break;
        case Directions.UP:
        case Directions.UPLEFT:
        case Directions.UPRIGHT:
            y = -1
            break;
    }
    switch (direction) {
        case Directions.LEFT:
        case Directions.DOWNLEFT:
        case Directions.UPLEFT:
            x = -1
            break;
        case Directions.RIGHT:
        case Directions.DOWNRIGHT:
        case Directions.UPRIGHT:
            x = 1
            break;
    }
    return {x: x, y: y}
}

export type DirectionXY = { y: 1 | -1 | 0; x: 1 | -1 | 0 }

export function directionOf(vY: number, vX: number, defaultDirection: Directions): Directions {
    if (vX == 0 && vY == 0)
        return defaultDirection

    if (vY < 0) {
        if (vX < 0)
            return Directions.UPLEFT
        if (vX > 0)
            return Directions.UPRIGHT

        return Directions.UP
    }
    if (vY > 0) {
        if (vX < 0)
            return Directions.DOWNLEFT
        if (vX > 0)
            return Directions.DOWNRIGHT

        return Directions.DOWN
    }
    if (vX < 0)
        return Directions.LEFT
    if (vX > 0)
        return Directions.RIGHT
}

export const REACH = 56 // 1.75 tiles — wider reach for mobile-friendly station interactions

export function convertDirectionToNormalizedXY(direction: Directions) {
    return normalize(convertDirectionToXY(direction));
}

export function pointRelativeTo(element: Position, direction: Directions, steps: number) {
    let orientation = convertDirectionToNormalizedXY(direction)
    let x: number = element.x + steps * REACH * orientation.x;
    let y: number = element.y + steps * REACH * orientation.y;
    return {x: x, y: y};
}

export function normalize(v: Position): Position {
    let ratio = Math.sqrt(v.x ** 2 + v.y ** 2);
    v.x /= ratio
    v.y /= ratio

    return v
}
